import { render, staticRenderFns } from "./TrainingCategoriesForm.vue?vue&type=template&id=8013f606&"
import script from "./TrainingCategoriesForm.vue?vue&type=script&lang=js&"
export * from "./TrainingCategoriesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports